var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"d2571cf0e9ef1d25f9cea01c7fc68e077a86062d"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// Sentry client initialization. Used when users load a page in their browser.

import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN,
  
  // Environment (development, production, etc.)
  environment: process.env.NODE_ENV,
  
  // Performance monitoring - lower rate for cost savings
  tracesSampleRate: 0.1,
  
  // Sample rate for error events (100% = 1.0)
  sampleRate: 1.0,
  
  // Enable debug in development only
  // debug: process.env.NODE_ENV === 'development',
});
